export interface DeviceMeta {
  locale: string | null;
  userAgent: string | null;
}

// Lightweight, dependency-free metadata for the app presence node (support /
// debugging dashboards). Reads only `navigator`, which exists on both the main
// thread and inside the SharedWorker (WorkerNavigator), so the worker can publish
// it without pulling in any DOM-only or Firebase code. We store the raw userAgent
// rather than parsing it here — a dashboard can derive browser/os/version
// server-side instead of shipping a UA parser into every embed.
export const getDeviceMeta = (): DeviceMeta => {
  if (typeof navigator === 'undefined') return { locale: null, userAgent: null };
  return {
    locale: navigator.language || null,
    userAgent: navigator.userAgent || null
  };
};
